/*
 * ttlReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio/DESKTOP-LBDL00N
 * @since 01-Oct-2024
 */

// import produce from 'immer';
// import { actionTypes } from '../actions/ttl';

const ACTION_HANDLERS = {
  // @generator reducer:type:action
}

// The initial state of the ttl
const initialState = {
}

const ttl = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default ttl
